import { render, staticRenderFns } from "./ParticipationComments.vue?vue&type=template&id=3360af40"
import script from "./ParticipationComments.vue?vue&type=script&lang=js"
export * from "./ParticipationComments.vue?vue&type=script&lang=js"
import style0 from "./ParticipationComments.vue?vue&type=style&index=0&id=3360af40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports